/**
 * @author slak4170
 * */
import {
  RECEIVE_COST_VIEW_DATA,
  RECEIVE_COST_VIEW_DETAILED_DATA,
  RESET_COST_VIEW_DATA,
} from '../actions/costViewActions';
import initialState from './initialState';

export default function costViewReducer(state, { type, data }) {
  if (typeof state === 'undefined') {
    return initialState.costView;
  }

  if (type === RESET_COST_VIEW_DATA) {
    return {
      ...initialState.costView,
      isEmptyCostViewData: false
    };
  }

  if (type === RECEIVE_COST_VIEW_DATA) {
    return {
      ...state,
      costViewData: data,
      isEmptyCostViewData: !data || Object.keys(data).length === 0
    };
  }

  if (type === RECEIVE_COST_VIEW_DETAILED_DATA) {
    return {
      ...state,
      costViewDetailedData: data
    };
  }

  return state;
}
